<template>
  <div style="display: flex; flex-wrap: nowrap; align-items: center; justify-content: flex-start">
    <div class="short-name-wrapper" :title="value">
      <span class="short-name">{{ value || header.placeholder }}</span>
    </div>
  </div>
</template>

<script>
import { TableHeaderURL } from 'Lib/TypeDefs';

export default {
  name: 'CellUrl',
  props: {
    item: Object,
    header: TableHeaderURL,
  },
  computed: {
    value() {
      return this.item[this.header.prop || 'name'] || null;
    },
  },
};
</script>
